import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ScheduleItem } from '../SchedulerTypes';

interface NotesDialogProps {
  viewingNotes: ScheduleItem | null;
  onClose: () => void;
}

const NotesDialog: React.FC<NotesDialogProps> = ({ viewingNotes, onClose }) => {
  return (
    <Dialog open={viewingNotes !== null} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Notes</DialogTitle>
          <DialogDescription>
            {viewingNotes?.title} - {viewingNotes?.date} ({viewingNotes?.startTime} - {viewingNotes?.endTime})
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4 p-4 bg-muted/30 rounded-md whitespace-pre-wrap">
          {viewingNotes?.notes}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NotesDialog;
